import React from 'react';
import PropTypes from 'prop-types';
import { LinkElement } from '@els/els-react--link-element';
import { Icon } from '@els/els-react--icon';
import { EXPORT_TERMS_AND_CONDITIONS_LINK } from '../../ExportModalConstants';

import './ExportModalContentDisclaimer.scss';

function ExportModalContentDisclaimer({ data }) {
  const { exportAttemptsLimit, exportAttemptsCurrentlyUsed } = data;

  const renderLimitWarning = () => {
    if (!exportAttemptsLimit || !exportAttemptsCurrentlyUsed) {
      return null;
    }

    if (exportAttemptsLimit - exportAttemptsCurrentlyUsed > 1) {
      return <span>{`This is export attempt ${exportAttemptsCurrentlyUsed} out of ${exportAttemptsLimit} for today.`}</span>;
    }

    if (exportAttemptsLimit - exportAttemptsCurrentlyUsed === 1) {
      return (
        <span>{`This is export attempt ${exportAttemptsCurrentlyUsed}. You are approaching your export limit of ${exportAttemptsLimit} for today.`}</span>
      );
    }

    if (exportAttemptsLimit === exportAttemptsCurrentlyUsed) {
      return <span>{`This is export attempt ${exportAttemptsCurrentlyUsed}. This is final export for today.`}</span>;
    }

    return null;
  };

  return (
    <div className="exportModal__disclaimer disclaimer">
      <div className="exportModal__content_row">
        <Icon className="u-els-margin-right-1o2" sprite="InformationSolidSquare" color="secondary" size="m" isDecorative />
        <div className="disclaimer__content">
          {renderLimitWarning()}
          <span>
            <b>Disclaimer:</b> please refer to our{' '}
            <LinkElement
              data-e2e="export-modal-terms-link"
              href={EXPORT_TERMS_AND_CONDITIONS_LINK}
              isExternal
              noExternalIcon
              inline
              className="e2e-export-modal-content-link">
              Terms and Conditions
            </LinkElement>{' '}
            before downloading data.
          </span>
        </div>
      </div>
    </div>
  );
}

ExportModalContentDisclaimer.propTypes = {
  data: PropTypes.object,
};

export default ExportModalContentDisclaimer;
